// extracted by mini-css-extract-plugin
module.exports = {"textDecorator":"component-module--text-decorator--xSEKy"};